import type { AirportWithActive } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const airportsActivityGet = () => coreRequestService<AirportWithActive[]>({
    url: '/airports/activity',
    method: 'GET'
});
